import { Action, createReducer, on } from '@ngrx/store';
import * as FilterActions from './filter.actions';
import { FilterState } from './filter.state';
import { Convert } from '../../models/filter-model';

const initialState: FilterState = {
  filter: {
    categories: [],
    breeds: [],
    ageRange: { minAge: 0, maxAge: 100 }
  }
};
export const filterReducer = createReducer(
  initialState,
  on(FilterActions.setFilter, (state, { filter }) => ({
    ...state,
    filter: Convert.getDefaultFilterModel(), // Correctly update the filter state
  }))
);
